
import ico1 from '@/assets/ad2.png'
import user from '@/assets/user-06.png'
import { geticonlist, getshoplist, getaddlog, getlist } from '@/api/hgfw'
import Grid from 'vux/src/components/grid/grid.vue'
import GridItem from 'vux/src/components/grid/grid-item.vue'
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'
import Swiper from 'vux/src/components/swiper/swiper.vue'

import { operateCreditlist  } from '@/api/user.js'
import Scroll from '@/components/scroller'
import config from '@/config/index.js'
export default {
data () {
return {
a: '1',
ico1,
user,
iconlist: '',
shoplist: [],
bannerlist: [],
baseUrl:config.baseUrl,
notFirstLoad: false,
loadMoreDom: null,
page:1,
rows:10,
baseUrl:config.baseUrl
}
},
methods: {
bannerclick () {

},
onItemClick (item) {

window.open(item.link)
},
shopClick (item) {

window.open(item.link)
},

icon () {
geticonlist({ page: 1, rows: '10' }).then(res => {
this.iconlist = res.returnValue.rows
})
},

shop (type, done) {
getshoplist({
page: this.page,
rows: this.rows
}).then(res => {
if (type === 'refresh' || type === 'search') {
this.shoplist = []
this.listDom.scrollTop = 0
}if (res.returnValue.rows !== '' && res.returnValue.rows.length > 0) {
res.returnValue.rows.forEach(item => {
this.shoplist.push({
id: item.id,
link: item.link,
picpath: item.picpath,
titlename: item.titlename
})
})
}
if (res.returnValue.total === 0) {
this.notFirstLoad = true
} else {
this.notFirstLoad = false
}
if (
res.returnValue.rows.length === 0 ||
res.returnValue.total < this.rows
) {
console.log(this.loadMoreDom)
this.loadMoreDom.innerText = '我也是有底线的～o～'
setTimeout(() => {
this.loadMoreDom.style.display = 'none'
}, 2000)
}
done && done()
})
},

refresh (done,index) {
this.page = 1
this.loadMoreDom.innerText = '加载中...'
this.shop('refresh', done)
},

loadMore (done) {
this.page++
this.shop('more', done)
},

list () {
getlist({ phtype: 1 }).then(res => {
let bannerlist = []
res.returnValue.rows.map((val, index, arr) => {
let list = {
url: val.link,
img: this.baseUrl + val.picpath
}
bannerlist.push(list)
})
this.bannerlist = bannerlist
})
},

add (id) {
try {
getaddlog({
accountid:this.accountid,
moduleid: 1200,
submoduleid: 120102
}).then(res => {
console.log(res)
})
} catch (error) {}
},

addIntegral(credit){
operateCreditlist({
accountid: this.accountid,
rulecode: 'hgfw_rule',

owner_type: '2007',
relationtype: 2,
relationid: 1,
terminaltype: 2
}).then(res => {})
},
},
computed: {
accountid () {
return this.$store.state.user.accountid
}
},
mounted () {
this.add()
this.addIntegral()
this.list()
this.icon()
this.shop()
this.loadMoreDom = this.$el.querySelector('.load-more')
this.listDom = this.$el.querySelector('.list-scroll')
},
components: {
Grid,
GridItem,
Flexbox,
FlexboxItem,
Swiper,
Scroll
}
}
